import { render, staticRenderFns } from "./JudicialRecoveries.vue?vue&type=template&id=fc7870a0&scoped=true&"
import script from "./JudicialRecoveries.vue?vue&type=script&lang=js&"
export * from "./JudicialRecoveries.vue?vue&type=script&lang=js&"
import style0 from "./JudicialRecoveries.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./JudicialRecoveries.vue?vue&type=style&index=1&id=fc7870a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7870a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
